import { theme } from 'antd';
import { ThemeConfigurationType } from '@monorepo/client-types';
import {
  clientPanelDarkTheme,
  commonComponentDarkTheme,
  commonComponentTheme,
  commonCssVars,
  commonDarkCssEnv,
  commonTtpCssVars,
} from './common.theme-settings';
import { fixedTtpToken } from './ttp-light-theme';

const token = {
  colorPrimary: '#FF569D',
  colorSuccess: '#2CD6E1',
  colorWarning: '#E9C10F',
  colorError: '#FF569D',
  colorInfo: '#719FF0',
  colorLink: '#256BE4',
};

const extraToken = {
  colorBrand: '#9356FF',
  colorAttention: '#2CD6E1',
  colorActive: '#EB0064',
  colorErrorLight: 'rgb(255, 208, 228)',
  colorSecondary: '#FF4D9E',
};
const runOverCommonCssVars = {
  'competition-color': 'var(--colorSuccess)',
};

export const DarkThemeConfigTtp: ThemeConfigurationType = {
  algorithm: theme.darkAlgorithm,
  token,
  components: { ...commonComponentTheme, ...commonComponentDarkTheme },
  cssVars: {
    ...commonCssVars,
    ...commonDarkCssEnv,
    ...commonTtpCssVars,
    ...token,
    ...extraToken,
    ...fixedTtpToken,
    ...clientPanelDarkTheme,
    ...runOverCommonCssVars,
    'color-text-button-primary': '#FFFFFF',
    'dropdown-hover-bg': 'var(--mui-palette-primary-main)',
    'dropdown-selected-bg': 'var(--mui-palette-primary-main)',
  },
};
